<div layout-horizontal>
  <rt-checkbox [formControl]="input.control" [disabled]="!!input.config.disabled">
    {{ input.config.checkboxLabel ? helpers.buildText(input.config.checkboxLabel) : null }}
  </rt-checkbox>
  @if (input.config.helpTooltip) {
    <div margin-left-small-x (click)="toggle()" class="checkbox-tooltip">
      <rt-icon-help [rtTooltip]="helpers.buildText(input.config.helpTooltip)"></rt-icon-help>
    </div>
  }
</div>
